module.exports = __webpack_public_path__ + "static/media/34-11.056c4ff9.mp3";